import {ref} from 'vue'
import {BASE_URL} from "@/composables/url_config";
import {log} from "@/composables/useLog"
import axios from "axios";

const error = ref(null)

export const getServiceTypes = async (token) => {
    log("welcome in getServiceTypes")

    if (!token || token === "") {
        alert("No token in getServiceTypes")
        return {error: true, message: "No token provided", service_types: []}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/get_service_types_api'
        log("url=" + url)

        const result = await axios.get(url, {headers: headers})
        log("result.data din axios getServiceTypes")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in getServiceTypes")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la getServiceTypes", service_types: []}
    }
}

export const addServiceType = async (token, data) => {
    log("welcome in addServiceType")
    log("data:")
    log(data)

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/add_service_type_api'
        log("url=" + url)

        const payload = {
            name: data.name,
            description: data.description || null,
            active: data.active !== false,
            show_in_search: data.show_in_search || false,
            label_on_search_button: data.label_on_search_button || null
        }

        const result = await axios.post(url, payload, {headers: headers})
        log("result.data din axios addServiceType")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in addServiceType")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la addServiceType"}
    }
}

export const updateServiceType = async (token, data) => {
    log("welcome in updateServiceType")
    log("data:")
    log(data)

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/update_service_type_api'
        log("url=" + url)

        const payload = {
            id: data.id,
            name: data.name,
            description: data.description,
            active: data.active,
            show_in_search: data.show_in_search,
            label_on_search_button: data.label_on_search_button
        }

        const result = await axios.put(url, payload, {headers: headers})
        log("result.data din axios updateServiceType")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in updateServiceType")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la updateServiceType"}
    }
}

const useServiceTypesAPI = () => {
    return {error, getServiceTypes, addServiceType, updateServiceType}
}

export default useServiceTypesAPI
